<template>
    <Modal :title="t({ key: 'checkout.agent_mediation_title' })" size="m">
        <div>
            <p v-if="flightText">
                {{ flightText }}
            </p>
            <p v-if="ferryText">
                {{ ferryText }}
            </p>
            <p v-if="activityText">
                {{ activityText }}
            </p>
        </div>
    </Modal>
</template>

<script lang="ts">
    import { computed, defineComponent } from 'vue';
    import Modal from '@ui/components/Modal/Modal.vue';
    import { t } from '@shared/helpers/translation';
    import store from '@/store';
    import { Market } from '@shared/config/market/market.models';

    export default defineComponent({
        name: 'AgentMediationModal',
        components: { Modal },
        methods: { t },
        setup() {
            const market = computed((): Market => store.getters['general/getMarket']);

            const flightText = computed(() =>
                getText(
                    'checkout.agent_mediation_flight',
                    store.getters['cart/hasFlightProducts']
                )
            );
            const ferryText = computed(() =>
                getText(
                    'checkout.agent_mediation_ferry',
                    store.getters['cart/hasFerryProducts']
                )
            );
            const activityText = computed(() =>
                getText(
                    'checkout.agent_mediation_ticket',
                    store.getters['cart/hasActivityProducts']
                )
            );

            const getText = (key: string, hasProduct: boolean) => {
                return hasProduct
                    ? t({
                          key,
                          values: [market.value.name],
                      })
                    : '';
            };

            return {
                flightText,
                ferryText,
                activityText,
            };
        },
    });
</script>
